import './styles/main.css';
import { initApp } from './app.js';

// Enregistrement du Service Worker (généré par vite-plugin-pwa)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch(() => {});
  });
}

// Lancement de l'app
initApp();
